export enum PortalCacheTags {
  Invoice = `Invoice`,
  Contact = `Contact`,
  Quote = `Quote`,
  PaymentMethods = `PaymentMethods`,
}
